import SelectBasic from "./SelectBasic";

export default SelectBasic;
